import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconRightChevron({
  fill = 'var(--basic-text)',
  width = 12,
  height = 6,
  rotate,
}: SvgTypesProps & { rotate?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: rotate ? rotate : 'rotate(0deg)' }}
    >
      <path
        d="M10.6666 1.02911L7.23741 4.45835C6.554 5.14176 5.44596 5.14176 4.76254 4.45834L1.33331 1.02911"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
